import { SuperHeroTertiaryCard } from 'ui/components';

export const SuperHeroTertiaryCardFeature: React.FC<Umbraco.SuperHeroTertiaryCard> = ({ content }) => (
	<SuperHeroTertiaryCard {...content?.properties} />
);
